import { render, staticRenderFns } from "./AntecipacaoProfissional.vue?vue&type=template&id=634a6d96&scoped=true"
import script from "./AntecipacaoProfissional.vue?vue&type=script&lang=ts"
export * from "./AntecipacaoProfissional.vue?vue&type=script&lang=ts"
import style0 from "./AntecipacaoProfissional.vue?vue&type=style&index=0&id=634a6d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634a6d96",
  null
  
)

export default component.exports